"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURABLE_MODULE_ID = exports.ASYNC_METHOD_SUFFIX = exports.DEFAULT_FACTORY_CLASS_METHOD_KEY = exports.DEFAULT_METHOD_KEY = void 0;
exports.DEFAULT_METHOD_KEY = 'register';
exports.DEFAULT_FACTORY_CLASS_METHOD_KEY = 'create';
exports.ASYNC_METHOD_SUFFIX = 'Async';
exports.CONFIGURABLE_MODULE_ID = 'CONFIGURABLE_MODULE_ID';
